// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__2X3Ku","image":"Title_image__34C-_","title":"Title_title__30mS6"};